import React from 'react';
import styled from 'styled-components';

const SVG = styled.svg`
  width: 22px;
  fill: #333;
`;

const DownArrowKeyboard = props => {
  const { ...rest } = props;
  return (
    <SVG {...rest} viewBox="0 0 24 24">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
    </SVG>
  );
};

export default DownArrowKeyboard;